import { Divider } from "@/Components/v2/atoms/Divider";
import { CircularProgress } from "@/Components/v2/atoms/Progress";
import RoundedBorderContainer from "@/Components/v2/atoms/RoundedBorderContainer/RoundedBorderContainer";
import { Stack } from "@/Components/v2/atoms/Stack";
import { Typography } from "@/Components/v2/atoms/Typography";
import { HIDE_DECIMAL, NO_SYMBOL, useConfig } from "@/hooks/useConfig";
import { FormatCurrencyFunction } from "@/hooks/useConfig/types";
import { formatPercentage } from "@/pages/scenario-builder/utils";
// import RevenueToggle from "../RevenueToggle";
import ResultDisplay from "@/shared/components/ResultDisplay";

interface SummaryProps {
  spend: number;
  revenue: number;
  roi: number;
  loading?: boolean;
  formatCurrency: FormatCurrencyFunction;
}

const Summary: React.FC<SummaryProps> = ({ spend, revenue, roi, loading, formatCurrency }) => {
  const {
    config: { showReturnInsteadOfRevenue, revenueLabel },
  } = useConfig();
  const revenueFormatterOptions = showReturnInsteadOfRevenue
    ? { ...NO_SYMBOL, ...HIDE_DECIMAL }
    : HIDE_DECIMAL;
  if (loading) {
    return <CircularProgress size={150} sx={{ marginTop: "30rem" }} />;
  }

  return (
    <RoundedBorderContainer>
      <Stack direction="row" justifyContent="space-between" alignItems="center" mb={2}>
        <Typography variant="h5" fontWeight={600}>
          ROI Summary
        </Typography>
        {/* <RevenueToggle /> */}
      </Stack>

      <Divider sx={{ marginBottom: "1em" }} />
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="strech"
        spacing={2}
        maxWidth={900}
      >
        <ResultDisplay title={"Marketing ROI %"} result={formatPercentage(roi, true)} />
        <ResultDisplay title={"Marketing Spend"} result={formatCurrency(spend, HIDE_DECIMAL)} />
        <ResultDisplay
          title={`Marketing ${revenueLabel}`}
          result={formatCurrency(revenue, revenueFormatterOptions)}
        />
      </Stack>
    </RoundedBorderContainer>
  );
};

export default Summary;
